<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#173EA3"
      :is-full-page="fullPage"
    ></loading>
    <div class="col-12">
      <div class="card">
        <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
        <Toast />
        <div class="p-fluid formgrid grid" style="margin-top: 2%">
          <!-- <div class="field col-2 md:col-2">
            <span class="p-float-label">
              <InputText type="text" v-model="compliant_id" onkeypress="return event.charCode >= 48 && event.charCode <= 57"/><label
                for="compliant_id"
                >Complaint ID</label
              >
            </span>
          </div> -->
          
          <div class="field col-12 md:col-2" >
            <span class="p-float-label">
              <MultiSelect
              display="chip"
                id="User"
                filter
                v-model="complaint_status_dropdownItem"
                :options="complaint_status_dropdownItems"
                optionLabel="name"
              >
              </MultiSelect>
              <label for="complaint_status">Complaint Status</label>
            </span>
          </div>
          <div class="field col-12 md:col-2">
            <span class="p-float-label">
              <MultiSelect
                id="User"
                display="chip"
                filter
                v-model="complaint_type_dropdownItem"
                :options="complaint_type_dropdownItems"
                optionLabel="name"
              >
              </MultiSelect>
              <label for="complaint_type">Complaint Type</label>
            </span>
          </div>
          
          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <Calendar
                v-model="from_date"
                dateFormat="dd-mm-yy"
                :showIcon="true"
                :showTime="false"
                hourFormat="12"
              /><label>From Date</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <Calendar
                v-model="to_date"
                dateFormat="dd-mm-yy"
                :showIcon="true"
                :showTime="false"
                hourFormat="12"
              /><label>To Date</label>
            </span>
          </div>
          <div
            class="field col-12 md:col-2"
            v-if="
              showFirstFilter &&
              user_key &&
              (user_key == 'Admin' || user_key == 'admin')
            "
          >
            <span class="p-float-label">
              <Dropdown
                id="state"
                filter
                v-model="client_id_search"
                :options="client_id_dropdown"
                optionLabel="name"
                :optionValue="code"
                @change="get_vehicle_type_master"
              ></Dropdown>
              <label>Select Client</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect
                id="User"
                filter
                v-model="district_dropdownItem"
                :options="district_dropdownItems"
                optionLabel="name"
                @change="getBlockData"
                
              >
              </MultiSelect>
              <label for="complaint_status">District</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            <span class="p-float-label">
              <MultiSelect
                id="User"
                filter
                v-model="block_dropdownItem"
                :options="block_dropdownItems"
                optionLabel="name"
                :loading ="set_loading"
              >
              </MultiSelect>
              <label for="complaint_status">Block</label>
            </span>
          </div>
          <div class="field col-12 md:col-2" v-if="showFirstFilter">
            
                        <MultiSelect 
                                   
                                    v-model="village_dropdownItem" 
                                    :options="village_dropdownItems" 
                                    optionLabel="name" 
                                    filter 
                                    display="chip"
                                    @filter="get_village"
                                    placeholder="Village" 
                                    
                                    >
                         
                            
                        </MultiSelect>

        </div>

          <div class="field col-12 md:col-2" v-if="showFirstFilter">
              <span class="p-float-label">
                <InputText maxlength="10"  format="text" v-model="phone" onkeypress="return event.charCode >= 48 && event.charCode <= 57"></InputText>
                <label for="phone">Mobile</label>
              </span>
          </div>  &nbsp;         
    
          <div class="field col-12 md:col-2">
            <Button v-if="!showFirstFilter" style="color: white; background: 
        lightgreen; border: none" icon="pi pi-ellipsis-h" @click="show_filter()"   v-tooltip.bottom="'more'"/>&nbsp;
            <Button
              icon="pi pi-search"
              v-tooltip.bottom="'Search'"
              @click="search(1)"
            />&nbsp;
            <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
            <!-- <a href="" @click="show_filter()">more ...</a> -->
            <!-- <button
              v-if="!showFirstFilter"
              style="color: blue; background: none; border: none"
              @click="show_filter()"
            >
              more ...
            </button> -->
            
          </div>
        </div>
       
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25, totalRecords]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">No records found.</b>
          </template>
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
            >
              <h5 class="m-0"><b> Complaint Master</b></h5>
              <!-- Total Records:{{totalRecords}} -->
              <!-- <Button
                icon="pi pi-refresh"
                @click="search(2)"
                v-tooltip.bottom="'Refresh'"
              /> -->
            </div>
            <div style="text-align: right; font-weight: bold">
              <span>Total Complaints:</span>{{ totalRecords }}
            </div>
          </template>
          <Column header="Action" headerStyle="min-width:13rem;">
              <template #body="slotProps">
                
                <Button
                  icon="pi pi-eye"
                  v-tooltip.bottom="'View'"
                  class="p-button-rounded p-button-Info mr-2"
                  @click="viewProduct(slotProps.data)"
                  size="small"
                />
                <!-- <Button
                  v-if="slotProps.data.complaint_status_name!='Closed'"
                  v-tooltip.bottom="'Update'"
                  class="p-button-rounded p-button-success mr-2"
                  @click="editProduct(slotProps.data)"
                  label="Update"
                  size="small"
                /> -->
                <Button
                  class="p-button-rounded p-button-success mr-2"
                  @click="Approval(slotProps.data)"
                  label="Action"
                  size="small"
                />
                
               
              </template>
            </Column>
          <Column header="Sr No" style="min-width: 5rem; text-align: center">
            <template #body="{ index }">
              <span v-if="page_no == 1">{{ +index + +1 }}</span>
              <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
            </template>
          </Column>
          <Column header="Comp. ID" :field="columns[1]" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.complaint_id }}
            </template>
          </Column>
          <Column
            header="Complaint By"
            :field="columns[1]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.complaint_by_name }}
            </template>
          </Column>
          <Column header="Mobile" :field="columns[1]" style="min-width: 8rem">
            <template #body="{ data }">
              {{ data.complaint_by_contact }}
            </template>
          </Column>
          <Column
            header="Complaint Date"
            :field="columns[1]"
            style="min-width: 8rem"
          >
            <template #body="{ data }">
              {{ dateFormatDMY(data.complaint_date) }}
            </template>
          </Column>
          <Column
            header="Status"
            :field="columns[1]"
            style="min-width: 5rem"
          >
            <template #body="{ data }">
              {{ data.complaint_status_name }}
            </template>
          </Column>
          <Column
            header="Complaint Type"
            :field="columns[1]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.complaint_type_name }}
            </template>
          </Column>
          <!-- <Column
            header="Village Code"
            :field="columns[1]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.village_code }}
            </template>
          </Column> -->
          <Column
            header="Village Name"
            :field="columns[1]"
            style="min-width: 15rem"
          >
            <template #body="{ data }">
              {{ data.village_code }} - {{ data.village_name }}
            </template>
          </Column>
          
          <Column
            header="District Name"
            :field="columns[2]"
            style="min-width: 15rem"
          >
            <template #body="{ data }">
              {{ data.district_code }} - {{ data.district_name }}
            </template>
          </Column>
         
          <!-- <Column
            header="Block Code"
            :field="columns[2]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.block_code }}
            </template>
          </Column> -->
          <Column
            header="Block Name"
            :field="columns[2]"
            style="min-width: 15rem"
          >
            <template #body="{ data }">
              {{ data.block_code }} - {{ data.block_name }}
            </template>
          </Column>
          
          <!-- <Column
            header="State Code"
            :field="columns[2]"
            style="min-width: 10rem"
          >
            <template #body="{ data }">
              {{ data.state_code }}
            </template>
          </Column> -->
          <Column
            header="State Name"
            :field="columns[2]"
            style="min-width: 15rem"
          >
            <template #body="{ data }">
              {{ data.state_code }} - {{ data.state }}
            </template>
          </Column>
          
        </DataTable>
        <Dialog
          header="Complaint Process"
          v-model:visible="approval_productDialog"
          :breakpoints="{ '960px': '75vw' }"
          :style="{ width: '70vw' }"
          :modal="true"
        >
        <div class="col-12">
          <!-- process_type_id="1"  complaint -->
          <Approval_UI  :product="product" 
                        :process_type_id="1"
                        :RoleID="RoleID"
                        :table="table_name"
                        :current_ApplicationStatus="product.application_status_id"
                        @on_submit="update_approval"
                        
          ></Approval_UI>
        </div>
        </Dialog>
        <Sidebar
            v-model:visible="productDialog"
            :baseZIndex="1000"
            position="full"
          >
          <div class="col-12">
            <div class="card">
              <h5>Complaint Details</h5>
                <hr />
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                    <span class="p-float-label">
                  <InputText
                    id="complaint_id"
                    type="text"
                    v-model.trim="product.complaint_id"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.complaint_id }"
                  />
                  <label for="complaint_id">Complaint ID</label>
                </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="complaint_by_name"
                    type="text"
                    v-model.trim="product.complaint_by_name"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.complaint_by_name }"
                  />
                  <label for="complaint_by_name">Complaint By</label>
                </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="complaint_by_contact"
                    type="text"
                    v-model.trim="product.complaint_by_contact"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.complaint_by_contact }"
                  />
                  <label for="complaint_by_contact">Mobile</label>
                </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="complaint_date"
                    type="text"
                    v-model.trim="product.complaint_date"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.complaint_date }"
                  />
                  <label for="complaint_date">Complaint Date</label>
                </span>
                </div>
                
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <Dropdown
                        display="chip"
                        id="User"
                        filter
                        v-model="complaint_type_get"
                        :options="complaint_type_dropdownItems"
                        optionLabel="name"
                        disabled
                        
                      >
                  </Dropdown>
                <label for="complaint_status">Complaint Type</label>
                  </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="village_name"
                    type="text"
                    v-model.trim="product.village_name"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.village_name }"
                  />
                  <label for="village_name">Village</label>
                </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="block_name"
                    type="text"
                    v-model.trim="product.block_name"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.block_name }"
                  />
                  <label for="block_name">Block</label>
                </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="district_name"
                    type="text"
                    v-model.trim="product.district_name"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.district_name }"
                  />
                  <label for="district_name">District</label>
                </span>
                </div>
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <InputText
                    id="state"
                    type="text"
                    v-model.trim="product.state"
                    required="true"
                    autofocus
                    disabled
                    :class="{ 'p-invalid': submitted && !product.state }"
                  />
                  <label for="state">State</label>
                </span>
                </div>
              </div>
              <hr>
              <div class="p-fluid formgrid grid">
                <div class="field col-6 md:col-3" style="margin-top: 1%;">
                  <span class="p-float-label">
                <Dropdown
                        display="chip"
                        id="User"
                        filter
                        v-model="complaint_status_get"
                        :options="complaint_status_dropdownItems"
                        optionLabel="name"
                        :disabled="show==false"
                        
                        
                      >
              </Dropdown>
                <label for="complaint_status">Complaint Status <b style="color:red">*</b></label>
                  </span>
                </div>
                <div class="field col-6 md:col-9" style="margin-top: 1%;">
                </div>
                <div class="field col-12 md:col-12" style="margin-top: 1%;">
                  <span class="p-float-label">
                  <Textarea inputId="remark" rows="3" cols="30" v-model="product.remark" :disabled="show==false"></Textarea>
                  <label for="remark">Remark <b style="color:red">*</b></label>
                </span>
                </div>
                <div class="field col-12 md:col-10" style="margin-top: 1%;"></div>
                <div class="field col-12 md:col-2" style="margin-top: 1%;"><Button
                  v-if="product._id && show==true"
                  label="Save"
                  @click="update_complaint"
                  class="p-button-success"
                  /></div>
              </div>
            </div>
          </div>
          
            
            
       
        </Sidebar>
        
        
      </div>
    </div>
  </div>
</template>
<script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import JsonExcel from "vue-json-excel";
import BreadcrumbService from "../service/BreadcrumbService";
import Approval_UI from '../components/menu/Approval_UI'
//import FormNewsMaster from "@/components/FormNewsMaster";

// import axios from "axios";
import apis from "@/apis";
import axios from "axios";
import { log } from "util";
export default {
  data() {
    return {
      RoleID:localStorage.getItem('role_id'),
      table_name:'complaint_status',
      show:false,
      set_loading:false,
      compliant_id: "",
      compliant_by: "",
      mobile_no: "",
      village_code: "",
      district_code: "",
      block_code: "",
      from_date: "",
      to_date: "",
      village_name: "",
      block_name: "",
      state_name: "",
      phone:'', 
      showFirstFilter: false,
      complaint_type_dropdownItems: [],
      complaint_type_dropdownItem: null,
      complaint_status_dropdownItems: [],
      complaint_status_dropdownItem: null,
      complaint_status_get:null,
      complaint_type_get:null,
      client_id_dropdown: [],
      client_id_search: "",
      district_dropdownItems: [],
      district_dropdownItem: null,
      block_dropdownItems: [],
      block_dropdownItem: null,
      village_dropdownItems: [],
      village_dropdownItem: null,
      user_key: "",
      place_details: "",
      end_place_details: "",
      searchme: "",
      name: "",
      page_no: 1,
      isLoading: false,
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      file_attachment: "",
      icon_dropdown: [],
      service_name: "",
      dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "InActive", value: "InActive" },
        { name: "Deleted", value: "Deleted" },
      ],
      parent_dropdownItems: [],
      selectstatus: { name: "", value: "" },
      parent_selectstatus: { name: "", value: "" },
      pick_icon: { name: "", value: "" },
      products: null,
      productDialog: false,
      approval_productDialog :false,

      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      // selectstatus2: { name: "Motivational", value: "Motivational" },
      limit: 10,
      columns: [],
      head: [
        "Data Usages",
        "Network Connectivity",
        "Students",
        "Teachers",
        "Student Registration",
        "News Master",
        "Government Panel",
        "Feedback Master",
        "User Queries",
        "Schemes Master",
        "Notice Master",
        "Subject Master",
        "Teacher Schedule Master",
        "Teacher Schedule DE Master",
        "Query Types Master",
        "Sub Query Types Master",
        "Admin Users",
        "Application Roles",
        "Departments",
        "Cast Master",
        "Year Master",
        "District Master",
        "Student Attendance",
        "Student Document",
        "Teachers",
        "Radical ids",
        "Subject Topics",
        "Query Comments",
        "Student Submit Answers",
        "Mock Tests",
        "Mock Test Papers",
        "Mock Test Results",
        "Video",
        "Syllabus",
        "Course",
      ],
      pageno: 1,
      submitted: false,
      icons: null,
      totalRecords: 0,
      id: "",
      statuses: [
        { label: "INSTOCK", value: "instock" },
        { label: "LOWSTOCK", value: "lowstock" },
        { label: "OUTOFSTOCK", value: "outofstock" },
      ],
      BreadcrumbService: null,
      breadcrumbHome: {},
      breadcrumbItems: [],
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.user_key = localStorage.getItem("user_key");
    this.initFilters();
    this.get_client_list();
    this.getComplaintTypeList();
    this.getComplaintStatusList();
    this.getDistrictData();
    this.getBlockData();
    //this.getVillageData();
    this.showFirstFilter = false;
    this.BreadcrumbService = new BreadcrumbService();
    let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
      "Complaint Master",
      "/complaint_master"
    );
    this.breadcrumbHome = Breadcrum_data.home;
    this.breadcrumbItems = Breadcrum_data.items;
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
    //alert(this.id);
  },
  watch: {
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  methods: {
    async update_approval(remark,approval_status)
    {
      var data = {
          
          "complaint_id":this.product._id,
          "user_id":localStorage.getItem("id"),
          "complaint_status":approval_status,
          "remark":remark
         
        };
        this.isLoadingModel = true;
        var promise = apis.updateComplaintStatus(data);
        promise
          .then((responseapi) => {
            this.$toast.add({ severity: 'success', summary: 'Success', detail: responseapi.data.message, life: 3000 });
            //this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.approval_productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
          
            this.isLoadingModel = false;
            this.productDialog = false;
            this.approval_productDialog = false;
            this.$toast.add({ severity: 'error', summary: 'error', detail: 'error.response.data', life: 3000 });
            //this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
    },
    async update_complaint()
    {
      if (this.product._id) 
      { 
        if (this.complaint_status_get && this.complaint_status_get.value=='') 
        {
              this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Complaint Status Error!!!",
              life: 3000,
            });
            return false;
        }

        if (this.product.remark=='') 
        {
              this.$toast.add({
              severity: "error",
              summary: "error",
              detail: "Remark Error!!!",
              life: 3000,
            });
            return false;
        }
        var data = {
          
          "complaint_id":this.product._id,
          "user_id":localStorage.getItem("id"),
          "complaint_status":this.complaint_status_get.value,
          "remark":this.product.remark
         
        };
        this.isLoadingModel = true;
        var promise = apis.updateComplaintStatus(data);
        promise
          .then((responseapi) => {
            this.$swal(responseapi.data.message);
            this.isLoadingModel = false;
            this.productDialog = false;
            this.get_list();
            this.get_count();
          })
          .catch((error) => {
          
            this.isLoadingModel = false;
            this.productDialog = false;
            this.$swal.fire(error.response.data);
            this.get_list();
            this.get_count();
          });
      }
    },
    get_village(search)
    {   
      var district_code = [];
      var block_code = [];
      if (this.district_dropdownItem) 
        {
            for (var d = 0; d < this.district_dropdownItem.length; d++) 
            {
                district_code.push(this.district_dropdownItem[d].value);
            }
        }
      if (this.block_dropdownItem) 
        {
            for (var c = 0; c < this.block_dropdownItem.length; c++) 
            {
                block_code.push(this.block_dropdownItem[c].value);
            }
        }

        var data = { 
            "count":false,
            "page_no":1,
            "limit":10,
            "search_name":search.value,
            district_code:district_code,
            block_code:block_code,
        };
        var promise = apis.getVillageData(data);
        promise.then((response) => {
          this.village_dropdownItems=[];
          var temp=response.data.data;
          for (let a = 0; a < temp.length; a++) {
            this.village_dropdownItems.push( { name: temp[a].village_name, value: temp[a].village_code });
            
          }
        });

    
    
    
    },
    dateFormatYMD(inputDate) {
        var postdate=inputDate;
        if(inputDate)
        {
            inputDate=new Date(inputDate);
            if(inputDate.toString()=='NaN-NaN-NaN')
            {
                return postdate;
            }
            else
            {
                let date = ("0" + inputDate.getDate()).slice(-2);
        // current month
                let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
                // current year
                let year = inputDate.getFullYear();
                if(date.toString()=='aN')
                {
                  return postdate;
                }
                else
                {
                  return year+"-"+month+"-"+date;
                }
            }
        }
        else {
           return "";
        }
    },
    show_filter() {
      this.showFirstFilter = true;
    },
    get_client_list() {
      var data = { count: false };
      var promise = apis.getclientist(data);
      promise.then((response) => {
        if (response.data.data) {
          response.data.data
            .filter((item) => item.client_name)
            .map((item) =>
              this.client_id_dropdown.push({
                name: item.client_name,
                code: item._id,
              })
            );
        }
      });
    },
    getDistrictData() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id,
        count: false,
      };
      var promise = apis.getStateData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.district_dropdownItem = null;
          this.district_dropdownItems = temp_data;
        }
      });
    },
    getBlockData() {
      this.block_dropdownItem = null;
      this.block_dropdownItems = [];
      var district_code = [];
      if (this.district_dropdownItem) 
        {
            for (var d = 0; d < this.district_dropdownItem.length; d++) 
            {
                district_code.push(this.district_dropdownItem[d].value);
            }
        }
    this.set_loading=true;
      var data = {
        district_code:district_code,
        count: false,
      };
      var promise = apis.getBlockData(data);
      promise.then((response) => {
        this.set_loading=false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].name,
              value: response.data.data[x].code,
            });
          }
          this.block_dropdownItem = null;
          this.block_dropdownItems = temp_data;
        }
      });
    },
    getVillageData() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        //client_id: client_id,
        count: false,
        service_name:"",
        limit:"",
        page_no:""
      };
      var promise = apis.getVillageData(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].village_name,
              value: response.data.data[x].code,
            });
          }
          this.village_dropdownItem = null;
          this.village_dropdownItems = temp_data;
        }
      });
    },
    getComplaintTypeList() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id,
      };
      var promise = apis.getComplaintTypeList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].complaint_type,
              value: response.data.data[x].id,
            });
          }
          this.complaint_type_dropdownItem = null;
          this.complaint_type_dropdownItems = temp_data;
        }
      });
    },
    getComplaintStatusList() {
      var client_id = this.client_id_search.code
        ? this.client_id_search.code
        : localStorage.getItem("client_id");
      this.loading = true;
      var data = {
        client_id: client_id,
      };
      var promise = apis.getComplaintStatusList(data);
      promise.then((response) => {
        this.loading = false;
        if (response.data.data) {
          var temp_data = [];
          for (let x = 0; x < response.data.data.length; x++) {
            temp_data.push({
              name: response.data.data[x].complaint_status,
              value: response.data.data[x].id,
            });
          }
          this.complaint_status_dropdownItem = null;
          this.complaint_status_dropdownItems = temp_data;
        }
      });
    },
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    reset()
    {
      this.client_id_search = "";
        this.service_name = "";
        this.showFirstFilter = false;
        this.complaint_status_dropdownItem = null;
        this.complaint_type_dropdownItem = null;
        this.compliant_id = "";
        this.compliant_by = "";
        this.mobile_no = "";
        this.phone="";
       
        this.from_date = "";
        this.to_date = "";
        
        this.village_dropdownItem=null;
        this.block_dropdownItem=null;
        this.district_dropdownItem=null;
        this.get_list();
        this.get_count();
    },
    async search(count) {
      if (count == 2) {
        this.client_id_search = "";
        this.service_name = "";
        this.showFirstFilter = false;
        this.complaint_status_dropdownItem = null;
        this.complaint_type_dropdownItem = null;
        this.compliant_id = "";
        this.compliant_by = "";
        this.mobile_no = "";
        this.phone="";
        //this.village_code = "";
        //this.district_code = "";
        //this.block_code = "";
        this.from_date = "";
        this.to_date = "";
        //this.village_name = "";
        //this.block_name = "";
        //this.state_name = "";
        this.village_dropdownItem=null;
        this.block_dropdownItem=null;
        this.district_dropdownItem=null;
        await this.getComplaintTypeList();
        await this.getComplaintStatusList();
        await this.getDistrictData();
        await this.getBlockData();
        //await this.getVillageData();
      }
      await this.get_list();
      await this.get_count();
    },
    async viewProduct(product) 
    {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      this.show=false;
      this.complaint_type_get = { name: "", value: "" } ;
      this.complaint_status_get = { name: "", value: "" } ;
      this.product.complaint_date=this.dateFormatDMY(this.product.complaint_date);
      this.complaint_status_get.name=this.product.complaint_status_name;
      this.complaint_status_get.value=this.product.complaint_status;
      this.complaint_type_get.name=this.product.complaint_type_name;
      this.complaint_type_get.value=this.product.complaint_type;
      //this.product.remark="";
      

    },
    Approval(product)
    {
      this.product = { ...product };
      this.approval_productDialog = true;
    },
    editProduct(product) 
    {
      this.file_attachment = "";
      this.product = { ...product };
      this.productDialog = true;
      
      this.show=this.product.complaint_status==4?false:true;  //4-closed
      this.complaint_type_get = { name: "", value: "" } ;
      this.complaint_status_get = { name: "", value: "" } ;
      this.product.complaint_date=this.dateFormatDMY(this.product.complaint_date);
      this.complaint_status_get.name=this.product.complaint_status_name;
      this.complaint_status_get.value=this.product.complaint_status;
      this.complaint_type_get.name=this.product.complaint_type_name;
      this.complaint_type_get.value=this.product.complaint_type;
      this.product.remark="";
      
    },
    isNumber(evt) {
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      }
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      //const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      var client_id = this.client_id_search.code ? this.client_id_search.code: localStorage.getItem("client_id");
      var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
        var complaint_type = [];
        var complaint_status = [];
        var block_code = [];
        var district_code = [];
        var village_code=[];
        if (this.complaint_type_dropdownItem) 
        {
            for (var a = 0; a < this.complaint_type_dropdownItem.length; a++) 
            {
                complaint_type.push(this.complaint_type_dropdownItem[a].value);
            }
        }
        if (this.complaint_status_dropdownItem) 
        {
            for (var b = 0; b < this.complaint_status_dropdownItem.length; b++) 
            {
                complaint_status.push(this.complaint_status_dropdownItem[b].value);
            }
        }
        if (this.block_dropdownItem) 
        {
            for (var c = 0; c < this.block_dropdownItem.length; c++) 
            {
                block_code.push(this.block_dropdownItem[c].value);
            }
        }
        if (this.district_dropdownItem) 
        {
            for (var d = 0; d < this.district_dropdownItem.length; d++) 
            {
                district_code.push(this.district_dropdownItem[d].value);
            }
        }
        if (this.village_dropdownItem) 
        {
            for (var e = 0; e < this.village_dropdownItem.length; e++) 
            {
                village_code.push(this.village_dropdownItem[e].value);
            }
        }
        

      var data = {
        count: true,
        complaint_date_from: this.dateFormatYMD(this.from_date),
        complaint_date_to: this.dateFormatYMD(this.to_date),
        phone:this.phone,
        district_code:district_code,
        block_code:block_code,
        complaint_type: complaint_type,
        complaint_status: complaint_status,
        village_code:village_code,
        compliant_by: this.compliant_by,
        mobile_no: this.mobile_no,
        "client_group_ids":client_group_ids,
        client_id:client_id,
        user_id:localStorage.getItem("id"),
      };
      this.loading = true;
      var promise = apis.getComplaintList(data);
      promise.then((response) => {
        this.loading = false;
        //   console.log(response);
        this.totalRecords = response.data.data;
        //alert(this.totalRecords);
      });
      // console.log(data);
    },
    get_list: function () {
      //const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      var client_id = this.client_id_search.code ? this.client_id_search.code: localStorage.getItem("client_id");
      var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
        var complaint_type = [];
        var complaint_status = [];
        var block_code = [];
        var district_code = [];
        var village_code=[];
        if (this.complaint_type_dropdownItem) 
        {
            for (var a = 0; a < this.complaint_type_dropdownItem.length; a++) 
            {
                complaint_type.push(this.complaint_type_dropdownItem[a].value);
            }
        }
        if (this.complaint_status_dropdownItem) 
        {
            for (var b = 0; b < this.complaint_status_dropdownItem.length; b++) 
            {
                complaint_status.push(this.complaint_status_dropdownItem[b].value);
            }
        }
        if (this.block_dropdownItem) 
        {
            for (var c = 0; c < this.block_dropdownItem.length; c++) 
            {
                block_code.push(this.block_dropdownItem[c].value);
            }
        }
        if (this.district_dropdownItem) 
        {
            for (var d = 0; d < this.district_dropdownItem.length; d++) 
            {
                district_code.push(this.district_dropdownItem[d].value);
            }
        }
        if (this.village_dropdownItem) 
        {
            for (var e = 0; e < this.village_dropdownItem.length; e++) 
            {
                village_code.push(this.village_dropdownItem[e].value);
            }
        }

        
      var data = {
        limit: this.limit,
        page_no: this.page_no,
        phone:this.phone,
        count: false,
        complaint_date_from: this.dateFormatYMD(this.from_date),
        complaint_date_to: this.dateFormatYMD(this.to_date),
        district_code:district_code,
        block_code:block_code,
        complaint_type: complaint_type,
        complaint_status: complaint_status,
        village_code:village_code,
        "client_group_ids":client_group_ids,
        client_id:client_id,
        user_id:localStorage.getItem("id"),
        
        //service_name: this.service_name,
        //compliant_id: this.compliant_id,
        compliant_by: this.compliant_by,
        mobile_no: this.mobile_no,
        //village_code: this.village_code,
        //district_code: this.district_code,
        //block_code: this.block_code,
        //village_name: this.village_name,
        //block_name: this.block_name,
        //state_name: this.state_name,
        
        
      };
      this.loading = true;
      var promise = apis.getComplaintList(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    formatCurrency(value) {
      if (value)
        return value.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
      return;
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.selectstatus = { name: "", value: "" };
      this.parent_selectstatus = { name: "", value: "" };
      this.pick_icon = { name: "", value: "" };
    },
    hideDialog() {
      this.productDialog = false;
      this.submitted = false;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      this.products = this.products.filter((val) => val.id !== this.product.id);
      this.deleteProductDialog = false;
      this.product = {};
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Product Deleted",
        life: 3000,
      });
    },
    deleteservice() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          user_id: localStorage.getItem("id"),
        };
        this.isLoadingModel = true;
        var promise = apis.deleteservicedata(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            // this.hideDialog1();
            this.deleteProductDialog = false;
            this.$swal(responseapi.data.message);
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Role");
          }
        });
      }
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.products.length; i++) {
        if (this.products[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteProductsDialog = true;
    },
    deleteSelectedProducts() {
      this.products = this.products.filter(
        (val) => !this.selectedProducts.includes(val)
      );
      this.deleteProductsDialog = false;
      this.selectedProducts = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Products Deleted",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
   components: {Approval_UI },
};
</script>
<style scoped lang="scss">
@import "../assets/demo/badges.scss";
@import "../assets/demo/documentation.scss";
.icons-list {
  i {
    color: var(--text-color-secondary);
  }
}
</style>
